import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLicenseId = (state: StoreSchema) => state.license.cachedLicense.licenseId
